function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { action } from 'mobx';
import { maybeCall } from 'sdc-utilities';
import { async } from '../AsyncHelper';
import { defer } from '../Deferred';

import { entryMappers } from 'sdc-data-models';

export var Creating = function Creating(superclass) {
  return function (_superclass) {
    _inherits(_class2, _superclass);

    function _class2() {
      var _temp, _this, _ret;

      _classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _superclass.call.apply(_superclass, [this].concat(args))), _this), _this.afterCreate = null, _this.createToEntry = entryMappers.createToEntry, _this.create = function (entry) {
        return function (event) {
          return defer(function (deferred) {
            return async(_this.api.create(entry)).then(_this.addEntry(deferred));
          });
        };
      }, _this.addEntry = function (deferred) {
        return action(function (payload) {
          maybeCall(_this.clearSelected)();
          _this.selected = _this.createToEntry(payload);
          _this.dataList.push(_this.selected);

          deferred.resolve(_this.selected);

          maybeCall(_this.afterCreate)(_this.selected);
          maybeCall(_this.publishEvent)(_this.selected, 'created');
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return _class2;
  }(superclass);
};